
import TableList from "@components/templates/tablelist";
import { HttptPackageCodeList } from '@/service/inbound';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttptPackageCodeList,
    },
    computed: {
        SearchsData() {
            return [{
                label: this.$t('fbb.inbound.case_code', { defaultValue: "箱码" }),
                tag: 'vInput',
                key: 'EQ_boxBarcode',
                show: true,
            },
            {
                label: "SKU",
                tag: 'vInput',
                key: 'EQ_sku',
                show: true,
            }
            ]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width:60,
            }, {
                title: this.$t('fbb.inbound.case_code', { defaultValue: "箱码" }),
                key: 'boxBarcode'
            }, {
                title: "SKU",
                key: 'sku'
            }, {
                title: this.$t('fbb.accountmanage.amount', { defaultValue: "数量" }),
                key: 'qty'
            },
            {
                title: this.$t('global.common.actions', { defaultValue: "操作" }),
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, this.$t('fbb.inbound.choose', { defaultValue: "选择" }))
                }
            }]
        }
    }

};
